import LocationsUnstyled from './unstyled'
import styled from 'styled-components'

const Locations = styled(LocationsUnstyled)`
  table {
    margin-left: -5px;
    min-width: 1335px;
  }
  .locations-import-button {
    margin-left: -20px;
  }
  .add-button-link {
    min-width: auto;
    padding: 0 7px;
    margin-bottom: 3px;
    span {
      margin: 0;
    }
    svg {
      width: 25px;
      height: 25px;
    }
  }
  .type-buttons {
    display: flex;
    margin: 40px;
    .transparent input {
      background-color: hsla(0, 0%, 0%, 0.09);
      color: ${props => props.theme.colors.primary};
      border: 0;
    }
    .transparent input[disabled] {
      color: #dcdcdc;
    }
  }
`

export default Locations
